// Picks up all select tags available on the page containing the 'custom-select' class
// and loops through them.

const customSelects = document.getElementsByClassName('custom-select');
const numberOfSelects = customSelects.length;

const closeAllSelect = (clickedElement) => {
    const optionDivs = document.getElementsByClassName('dropdown-mask__items');
    const selectedDivs = document.getElementsByClassName('dropdown-mask');
    const optionDivsLength = optionDivs.length;
    const selectedDivsLength = selectedDivs.length;
    const excludeIndexes: number[] = [];

    for (let i = 0; i < selectedDivsLength; i += 1) {
        if (clickedElement === selectedDivs[i]) {
            excludeIndexes.push(i);
        } else {
            selectedDivs[i].classList.remove('dropdown-mask__select-arrow-active');
        }
    }

    for (let i = 0; i < optionDivsLength; i += 1) {
        if (!excludeIndexes.includes(i)) {
            optionDivs[i].classList.add('dropdown-mask__hide');
        }
    }
};

for (let i = 0; i < numberOfSelects; i += 1) {
    const selectElement = customSelects[i].getElementsByTagName('select')[0];
    const numberOfOptions = selectElement.length;

    const selectedDiv = document.createElement('DIV');

    selectedDiv.setAttribute('class', 'dropdown-mask');
    selectedDiv.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML;
    customSelects[i].appendChild(selectedDiv);

    const optionsContainerDiv = document.createElement('DIV');

    optionsContainerDiv.setAttribute('class', 'dropdown-mask__items dropdown-mask__hide');

    for (let j = 0; j < numberOfOptions; j += 1) {
        const optionDiv = document.createElement('DIV');

        optionDiv.innerHTML = selectElement.options[j].innerHTML;

        optionDiv.addEventListener('click', function optionDivClickHandler() {
            const selectedOption = (this.parentNode?.parentNode as HTMLElement)?.getElementsByTagName('select')[0];
            const selectedLength = selectedOption.length;
            const selectedDisplay = this.parentNode?.previousSibling;

            for (let k = 0; k < selectedLength; k += 1) {
                if (selectedOption.options[k].innerHTML === this.innerHTML) {
                    selectedOption.selectedIndex = k;

                    if (selectedDisplay instanceof Element) {
                        selectedDisplay.innerHTML = this.innerHTML;
                    }

                    const selectedItems = (this.parentNode as HTMLElement)?.getElementsByClassName('dropdown-mask__same-as-selected');
                    const numberOfSelectedItems = selectedItems.length;

                    for (let l = 0; l < numberOfSelectedItems; l += 1) {
                        selectedItems[l].removeAttribute('class');
                    }

                    this.setAttribute('class', 'dropdown-mask__same-as-selected');
                    break;
                }
            }

            if (selectedDisplay instanceof HTMLElement) {
                selectedDisplay.click();
            }
        });

        optionsContainerDiv.appendChild(optionDiv);
    }

    customSelects[i].appendChild(optionsContainerDiv);

    selectedDiv.addEventListener('click', function optionDivClickCloseHandler(e) {
        e.stopPropagation();
        closeAllSelect(this);

        if (this.nextSibling instanceof Element) {
            this.nextSibling.classList.toggle('dropdown-mask__hide');
        }

        this.classList.toggle('dropdown-mask__select-arrow-active');
    });
}

document.addEventListener('click', closeAllSelect);

export {};
